export interface AlertRecipient {
    _id: string;
    name: string;
    email: boolean;
    sms: boolean;
    voice: boolean;
  }
  
  export interface UserRef {
    _id?: string;
    name?: string;
  }
  
  export interface TeamAlertArrays {
    email: UserRef[];
    sms: UserRef[];
    voice: UserRef[];
  }
  
  export function mergeTeamRecipients(
    email: UserRef[] = [],
    sms: UserRef[] = [],
    voice: UserRef[] = []
  ): AlertRecipient[] {
    const map = new Map<string, AlertRecipient>();
  
    const add = (list: UserRef[], channel: 'email' | 'sms' | 'voice') => {
      (list || []).forEach((user) => {
        if (!user?._id) return;
        const existing = map.get(user._id) || {
          _id: user._id,
          name: user.name || '',
          email: false,
          sms: false,
          voice: false,
        };
        existing[channel] = true;
        if (user.name) existing.name = user.name;
        map.set(user._id, existing);
      });
    };
  
    add(email, 'email');
    add(sms, 'sms');
    add(voice, 'voice');
  
    return Array.from(map.values());
  }
  
  export function splitTeamRecipients(recipients: AlertRecipient[]): TeamAlertArrays {
    const email: UserRef[] = [];
    const sms: UserRef[] = [];
    const voice: UserRef[] = [];
  
    (recipients || []).forEach((recipient) => {
      const ref = { _id: recipient._id, name: recipient.name };
      if (recipient.email) email.push(ref);
      if (recipient.sms) sms.push(ref);
      if (recipient.voice) voice.push(ref);
    });
  
    return { email, sms, voice };
  }
  
  export function getInitials(name: string): string {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
  }
  
  export function hasOfficeNumber(officenumber?: string | null): boolean {
    return !!(officenumber && String(officenumber).trim());
  }